import React, { createRef } from "react";
import { InputFactory, InputJson } from "nq-component";
import BaseFormPage from "../../../../../base/BaseFormPage";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import OfficeFormPresenter from "../../../../OrganizationaStructure/offices/office-form/OfficeFormPresenter";
import NavBar from "../../../../../components/navigation";
import withRouter from "../../../../../withRouter";
import CardView from "../../../../../components/common/CardView";
import SearchSelect from "../../../../../components/searchSelect/SearchSelect";
import ViewAccomplishment from "./ViewAccomplishment";
import {
  FloatingForm,
  SubmitImg,
} from "../../../../../components/common/Converter";
import FileUpload from "../../../../../components/common/FileUpload";

class AccomplishmentEmployeeForm extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      isCommendationOpen: false,
      title: "",
      description: "",
      type: "",
      objectID: "",
      viewAccomplishment: [],
      selectedFiles: [],
    };
    this.presenter = new OfficeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
    this.childRef = createRef();
  }

  // async componentDidUpdate(prevProps, prevState) {
  //   if (prevState.object !== this.state.object) {
  //     await this.fetchListOfEmployee();
  //   }
  // }

  // async fetchListOfEmployee() {
  //   const { object } = this.state;
  //   const employee = `${object.Firstname} ${object.Middlename} ${object.surname}`;
  //   const commendation = await findObjectUseCase().execute(
  //     "accomplishment_profile"
  //   );
  //   const viewAccomplishment = commendation.filter(
  //     (item) => item.employee === employee
  //   );
  //   console.warn("OBJET: ", viewAccomplishment);
  //   this.setState({ viewAccomplishment });
  // }

  getCollectionName() {
    return "employees";
  }
  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  handleCommendation() {
    this.setState({
      isCommendationOpen: true,
      title: "",
      description: "",
      type: "",
    });
  }

  // onReceiveData(object) {
  //   this.handleCommendation();
  //   this.setState({
  //     type: object.type,
  //     title: object.title,
  //     description: object.description,
  //     objectID: object.id,
  //   });
  // }

  inputChange = (field) => (value) => {
    this.setState({ [field]: value });
  };

  async handleSaveCommendation() {
    const { title, description, type, object, selectedFiles } = this.state;

    if (selectedFiles.length === 0) {
      this.showError("Attachment Required");
      return;
    }
    const file = await SubmitImg(selectedFiles);
    const data = {
      type,
      title,
      description,
      employeeID: object.id,
      selectedFiles: file,
      employee: `${object.Firstname} ${object.Middlename || ""} ${
        object.surname
      }`,
    };

    this.setState({ isCommendationOpen: false });
    this.showSuccess("Successfully saved!");
    await upsertUseCase().execute("commendation_list", data);
    this.childRef.current.refetchData();
  }

  handleFileChange(selectedFiles) {
    this.setState({ selectedFiles });
  }

  render() {
    const object = this.state.object;
    // console.log("UBOBBBB: ", object.id);
    const employeeID = object.id;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100 mt-5">
            <div className="p-lg-4">
              <div className="bg-white shadow rounded p-3">
                <div className="row">
                  {advanced ? (
                    <InputJson
                      defaultValue={object}
                      onChange={this.onChangeObject.bind(this)}
                      rows="15"
                    />
                  ) : (
                    <>
                      <div className="p-0">
                        <div className="p-3">
                          <h3 className="text-primary">
                            Accomplishment Profle
                          </h3>
                          <blockquote className="blockquote">
                            <h6>
                              First Name: <b>{object.Firstname}</b>
                            </h6>
                            <h6>
                              Middle Name: <b>{object.Middlename}</b>
                            </h6>
                            <h6>
                              Last Name: <b>{object.surname}</b>{" "}
                            </h6>
                          </blockquote>
                          <div className="d-flex justify-content-end gap-2">
                            <button
                              className="btn btn-primary"
                              onClick={this.handleCommendation.bind(this)}
                            >
                              <i className="bi bi-plus" /> Create Commendation
                            </button>
                            <button
                              className="btn btn-primary"
                              // onClick={this.handleCommendation.bind(this)}
                              onClick={this.navigateBack.bind(this)}
                            >
                              <i className="bi bi-arrow-return-left" /> Back
                            </button>
                          </div>
                        </div>

                        <hr />
                        {employeeID && (
                          <ViewAccomplishment
                            employeeID={employeeID}
                            ref={this.childRef}
                            // onReceiveData={this.onReceiveData.bind(this)}
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.isCommendationOpen && (
          <>
            <FloatingForm width="30rem">
              <CardView style={{ padding: 0 }}>
                <h4 className="fs-6 fw-bold pt-3 ps-3">Commendation Details</h4>
                <hr />
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleSaveCommendation();
                  }}
                >
                  <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                    <div className="mb-4">
                      <label className="mb-2">
                        Type <span className="text-danger">*</span>
                      </label>
                      <SearchSelect
                        value={this.state.type}
                        required
                        onChange={this.inputChange("type")}
                        onClickClear={() => this.setState({ type: "" })}
                        options={["Good", "Bad"].map((stats) => ({
                          label: stats,
                          value: stats,
                        }))}
                      />
                    </div>
                    <div className="mb-4">
                      {["Title", "Description"].map((label, index) => (
                        <>
                          <label className="mb-2" key={index}>
                            {label} <span className="text-danger">*</span>
                          </label>
                          <div className="col-lg-12 mb-4">
                            <InputFactory
                              required
                              type={label === "Title" ? "String" : "Text"}
                              value={this.state[label.toLowerCase()]}
                              onChange={(value) =>
                                this.inputChange(label.toLowerCase())(value)
                              }
                            />
                          </div>
                        </>
                      ))}

                      <div className="d-grid">
                        <label className="mb-2">
                          File Attachment <span className="text-danger">*</span>
                        </label>
                        <FileUpload
                          label={"Upload Attachments"}
                          attachments={this.state.selectedFiles}
                          disabled={this.state.isDisabled}
                          onFileChange={this.handleFileChange.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                    <button
                      className="btn btn-light"
                      onClick={() =>
                        this.setState({ isCommendationOpen: false })
                      }
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      // onClick={this.handleSaveCommendation.bind(this)}
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </CardView>
            </FloatingForm>
          </>
        )}
      </>
    );
  }
}

export default withRouter(AccomplishmentEmployeeForm);
